import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useSectionColors } from "./statusCardStyles";

/**
 * Displays the database services count in a styled box.
 * @param {object} props
 * @param {object|null} props.database - Database status data from API
 * @returns {React.ReactElement}
 */
function DatabaseSection({ database }) {
    const { boxBg, label, value } = useSectionColors();
    return (
        <Box p="14px" bg={boxBg} borderRadius="12px">
            <Flex justify="space-between" align="center">
                <Text fontSize="sm" color={label}>Services in database</Text>
                <Text fontSize="lg" fontWeight="700" color={value}>{database?.services_count || 0}</Text>
            </Flex>
        </Box>
    );
}

export default DatabaseSection;
